import { OutliersLimits, ReportTableData, SearchResponse } from "interfaces/dataInterfaces"
import { IOutliersData, OutliersFilters } from "interfaces/markets"
import { marketpricesApi } from "./marketpricesApi"

export const outlierapi = marketpricesApi.injectEndpoints({
  endpoints: builder => ({
    getOutliersByValue: builder.query<OutliersLimits[], { adm0Code?: number }>({
      query: ({ adm0Code }) => ({ url: "Outliers/GetByValue", method: "GET", params: { adm0Code } }),
      providesTags: [{ type: "OutliersGetByValue" as const, id: "LIST" }],
    }),

    checkDuplicates: builder.mutation<
      ReportTableData[],
      { adm0Code: number; frequencyId: string; series: { commodityPriceDate: string; seriesCombinationCode: string }[] }
    >({
      query: body => ({ url: "Outliers/CheckDuplicates", method: "POST", body }),
    }),

    getOutliersList: builder.query<SearchResponse<IOutliersData>, OutliersFilters>({
      query: params => ({ url: "Outliers/GetCommodityPricesByThresholds", method: "GET", params }),
      providesTags: ["OutliersList"],
    }),
  }),
})

export const { useGetOutliersByValueQuery, useCheckDuplicatesMutation, useLazyGetOutliersListQuery } = outlierapi
